import { Form } from "react-bootstrap"

interface SpecimenIdInputProps {
  className?: string
  readOnly?: boolean
  disabled?: boolean
  size?: "sm" | "lg"
  value: string
  isValid?: () => boolean
  onChange: (value: string) => void
}

const SpecimenIdInput = (props: SpecimenIdInputProps) => {
  return (
    <Form.Control type="text"
      className={props.className}
      readOnly={props.readOnly}
      disabled={props.disabled}
      value={props.value}
      isInvalid={!!props.isValid && !props.isValid()}
      onChange={(e) => props.onChange(e.target.value)} />
  )
}

export default SpecimenIdInput
